<template>
    <div class="share-btns">
        <div class="share-title">
            <a href="#" @click.prevent="open = !open">
                <h2>ПОДЕЛИТЬСЯ SOHO</h2>
                <svg-icon icon-class="share" className="icon-share"/>
            </a>
        </div>
        <div class="share-btns-container" :class="{open : open}">
            <button class="button btn-share-flat-to-social btn-share-flat-to-social-desctop" data-sharer="whatsapp" data-title="SOHO CITY WITHIN A CITY  Жилой квартал от Bazis-A" data-url="https://soho.bazis.kz" data-web><svg-icon icon-class="whatsapp-flat" className="flat-share-icon icon-whatsapp"/></button>
            <button class="button btn-share-flat-to-social btn-share-flat-to-social-mobile" data-sharer="whatsapp" data-title="SOHO CITY WITHIN A CITY  Жилой квартал от Bazis-A" data-url="https://soho.bazis.kz"><svg-icon icon-class="whatsapp-flat" className="flat-share-icon icon-whatsapp"/></button>
            <button class="button btn-share-flat-to-social" data-sharer="telegram" data-title="SOHO CITY WITHIN A CITY  Жилой квартал от Bazis-A" data-url="https://soho.bazis.kz"><svg-icon icon-class="telegram" className="flat-share-icon icon-telegram"/></button>
            <button class="button btn-share-flat-to-social" data-sharer="facebook" data-hashtag="SOHO_CITY_WITHIN_A_CITY_Bazis-A" data-url="https://soho.bazis.kz"><svg-icon icon-class="facebook-flat" className="flat-share-icon icon-facebook"/></button>
            <button class="button btn-share-flat-to-social" data-sharer="vk" data-title="SOHO CITY WITHIN A CITY Жилой квартал от Bazis-A" data-url="https://soho.bazis.kz"><svg-icon icon-class="vk-flat" className="flat-share-icon icon-vk"/></button>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'share',
        components: {
        },
        data () {
            return {
                open: false,
            }
        },
        methods: { 
        },
        computed: mapGetters({
        }),
        created () {
        },
        mounted () {
            window.Sharer.init();
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/share/share.scss';
    @import '@/styles/components/share/share-respond.scss';
</style>